module.exports = __webpack_public_path__ + "static/Riley-108-eaba8d65e87db404cd5b748850cd9078.jpg";